import { createContext, Dispatch } from 'react';
import {
  AccessibilityAction,
  AccessibilityState,
} from '../../types/accessibility/accessibility.types';
import { accessibilityInitialState } from './accessibility-reducer';

interface AccessibilityContextData {
  state: AccessibilityState;
  dispatch: Dispatch<AccessibilityAction>;
}

export const AccessibilityContext =
  createContext<AccessibilityContextData>({
    state: accessibilityInitialState,
    dispatch: () => null,
  });